import { IExternalLinkModel } from '@api/models';
import ConfirmationDrawer from '@library/drawer/components/ConfirmationDrawer';

interface ExternalLinkDrawerProps {
    show: boolean;
    onClose: () => void;
    externalLink: IExternalLinkModel;
}

const ExternalLinkDrawer = (props: ExternalLinkDrawerProps) => {
    const { show, onClose, externalLink } = props;

    const handleExternalLink = () => {
        window.open(externalLink.path, '_blank', 'noopener,noreferrer');

        onClose();
    };

    return (
        <ConfirmationDrawer
            open={show}
            onClose={onClose}
            title="External Link"
            message={
                <>
                    <h5 className="text-grayscale-900">Kindly review the below to proceed further</h5>

                    <div className="mt-2">
                        You are now being re-directed to a third party website. ProgressCenter assumes no liability,
                        control or responsibility for the accuracy, legality, content or any activity on this site.
                        Please visit ProgressCenter website terms and conditions for more details.
                    </div>
                </>
            }
            onConfirm={handleExternalLink}
            confirmText="Continue"
        />
    );
};

export default ExternalLinkDrawer;
